import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { commitHash, initializeSentry, SentryErrorBoundary } from '@paragon/client-tools';
import { initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';
import { ParagonThemeProvider } from '@paragon/themes';

import { loginAndStartApp } from './actions/appActions';
import RootComponent from './components/RootComponent';
import { store } from './store';
import { darkTheme, lightTheme } from './themes';

initializeSentry();
initializeDataConnectionsAndLoginTools(store);

store.dispatch(loginAndStartApp());
if (commitHash != null) console.log(`Commit hash: ${commitHash}`);

const root = createRoot(document.querySelector('.root-anchor')!);
root.render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <Provider store={store}>
        <ParagonThemeProvider darkTheme={darkTheme} lightTheme={lightTheme}>
          <RootComponent />
        </ParagonThemeProvider>
      </Provider>
    </SentryErrorBoundary>
  </React.StrictMode>,
);
